export const VERIFY = "verify";
export const DONOTCREATE = "doNotCreate";
export const CREATE = "create";

export const VERIFICATION_REQUIRED_ERROR = "verification_required";
export const INVALID_CODE = "invalid_code";
export const CONFIRMATION_REQUIRED_WITH_OPEN_MESSAGE = "confirmation_required_open_message";
export const DO_NOT_CREATE_WITH_OPEN_MESSAGE = "do_not_create_open_message";
export const VERIFICATION_CODE_REQUIRED = "verification_code_required";
export const VERIFICATION_CODE_REQUIRED_OPEN_MESSAGE = "verification_code_required_open_message";
